; (function () {
    var selectUsersNotHavingUserNamesModuleRouting = [
        {
            "name": "SelectUsersNotHavingUserNames",
            "templateUrl": "<div emr-select-users-not-having-user-names></div>",
            "RoutingNumber": 929,
            files: [
                "AngularScripts/SelectUsersNotHavingUserNamesModule/Services/SelectUsersNotHavingUserNamesService.js",
                "AngularScripts/SelectUsersNotHavingUserNamesModule/Controllers/SelectUsersNotHavingUserNamesController.js",
            ]
        }
    ];
    angular.module('EMR.SelectUsersNotHavingUserNamesModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(selectUsersNotHavingUserNamesModuleRouting, $stateProvider);
            }]);
})();